import * as React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { getHomeRedirectToLoginConfig, setHomeRedirectToLogin } from '@/modules/navigation/services/homeSettingsService'

export default function HomeAsLoginSetting() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getHomeRedirectToLoginConfig()
      .then((on) => { if (mounted) setEnabled(on) })
      .catch((e) => toast({ title: 'Página inicial', description: e?.message || 'Falha ao carregar configuração', variant: 'error' }))
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setHomeRedirectToLogin(next)
      setEnabled(next)
      toast({ title: 'Página inicial', description: next ? 'Definida como Login' : 'Mantida a página atual', variant: 'success', soft: true })
    } catch (e: any) {
      toast({ title: 'Página inicial', description: e?.message || 'Falha ao salvar configuração', variant: 'error' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Página inicial: Login</CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4">
          <div className="text-sm text-foreground/80">
            Quando ativada, a rota "/" passa a exibir a tela de Login (em vez da página inicial atual).
          </div>
          <div className="flex items-center gap-2">
            <Label>Desativado</Label>
            <Switch checked={enabled} onChange={(e)=> handleToggle((e.target as HTMLInputElement).checked)} disabled={loading || saving} />
            <Label>Ativado</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

